// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag-tag-2PbsW Card-card-1iGZk","label":"Tag-label-8svHM"};